import { Container, Paper } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPatients } from '../../store/patientsSlice';
import { AppDispatch, RootState } from '../../store/store';

/**
 * FAKE Actvity page for demonstration purposes
 */

const initialState = {
  criticalPatients: [
    { id: 1, lastName: 'Dupont', firstName: 'Martin', suicidalThoughts: 'Oui', nextConsultation: '02/03/2025', phq9Variation: '+ 10' },
    { id: 2, lastName: 'Michel', firstName: 'Marin', suicidalThoughts: 'Oui', nextConsultation: '18/03/2025', phq9Variation: '+ 8 points' },
    { id: 3, lastName: 'Morne', firstName: 'Christine', suicidalThoughts: 'Non', nextConsultation: '01/03/2025', phq9Variation: '+ 5 points' },
  ],
  patientsToMonitor: [
    { id: 4, lastName: 'Denis', firstName: 'Catherine', suicidalThoughts: 'Oui', nextConsultation: '02/03/2025', phq9Variation: '+ 4 points' },
    { id: 5, lastName: 'Hakiki', firstName: 'Maysanne', suicidalThoughts: 'Oui', nextConsultation: '18/03/2025', phq9Variation: '+ 4 points' },
    { id: 6, lastName: 'Camille', firstName: 'Paul', suicidalThoughts: 'Non', nextConsultation: '01/03/2025', phq9Variation: '+ 3 points' },
  ],
  fragilePatients: [
    { id: 7, lastName: 'Dupont', firstName: 'Martin', suicidalThoughts: 'Oui', nextConsultation: '02/03/2025', phq9Variation: '+ 4 points' },
    { id: 8, lastName: 'Michel', firstName: 'Marin', suicidalThoughts: 'Oui', nextConsultation: '18/03/2025', phq9Variation: '+ 3 points' },
    { id: 9, lastName: 'Morne', firstName: 'Christine', suicidalThoughts: 'Non', nextConsultation: '01/03/2025', phq9Variation: '+ 2 points' },
  ],
};

interface PatientTableProps {
  title: string;
  selectedPatients: {
    id: number;
    lastName: string;
    firstName: string;
    suicidalThoughts: string;
    nextConsultation: string;
    phq9Variation: string;
  }[];
}

const PatientTable: React.FC<PatientTableProps> = ({ title, selectedPatients }) => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const { patients } = useSelector((state: RootState) => state.patients);

  useEffect(() => {
    void dispatch(fetchPatients());
  }, [dispatch]);

  const columns: GridColDef[] = [
    { field: 'lastName', headerName: 'Nom', flex: 1 },
    { field: 'firstName', headerName: 'Prénom', flex: 1 },
    { field: 'suicidalThoughts', headerName: 'Idées suicidaires', flex: 1 },
    { field: 'nextConsultation', headerName: 'Prochaine consultation', flex: 1 },
    { field: 'phq9Variation', headerName: 'Variation PHQ-9', flex: 1 },
  ];

  const handleRowClick = () => {
    navigate(`/patient/${patients?.patients[0].id || '0'}/dashboard/general`);
  };

  return (
    <Container disableGutters sx={{ flex: 1, display: 'flex', flexDirection: 'column', p: 0 }}>
      <h2>{title}</h2>
      <Paper style={{ height: 400, width: '100%' }}>
        <DataGrid columns={columns} onRowClick={handleRowClick} rows={selectedPatients} />
      </Paper>
    </Container>
  );
};

const Activity: React.FC = () => {
  const { criticalPatients, patientsToMonitor, fragilePatients } = initialState;

  return (
    <div style={{ overflow: 'auto', height: '100%' }}>
      <PatientTable selectedPatients={criticalPatients} title="Patients critiques" />
      <PatientTable selectedPatients={patientsToMonitor} title="Patients à surveiller" />
      <PatientTable selectedPatients={fragilePatients} title="Patients fragilisés" />
    </div>
  );
};

export default Activity;
